<div class="chat-excel-file-block" *ngIf="isReady">
  <button
    class="chat-excel-file-block__bubble"
    type="button"
    [class.chat-excel-file-block__bubble--unavailable]="!isAvailable"
    [disabled]="!isAvailable || isDownloading"
    (click)="download()"
  >
    <span class="chat-excel-file-block__icon" aria-hidden="true">XLSX</span>

    <span class="chat-excel-file-block__body">
      <span class="chat-excel-file-block__name">{{ fileName }}</span>
      <span class="chat-excel-file-block__meta">{{ meta }}</span>
    </span>
  </button>
</div>
